export default __webpack_public_path__ + "static/media/judit-polgar.dc001a89.txt";